import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
	getActivityAreasDirectory,
	getObjectsTypesDirectory,
	getOrganizationsDirectory,
	getOwnershipTypesDirectory,
	getProcessClassesDirectory,
	getResponsiblesDirectory,
} from "./directories.thunks";
import { IProcessClassDirectory } from "./types";
import {
	ActivityAreaResponse,
	EmployeeSimpleResponse,
	ObjectTypeResponse,
	OrganizationSimpleResponse,
	OwnershipTypeResponse,
} from "libs/apiClient/data-contracts";

interface DirectoriesState {
	organizationsDirectory: OrganizationSimpleResponse[];
	processClassesDirectory: IProcessClassDirectory[];
	objectsTypesDirectory: ObjectTypeResponse[];
	activityAreasDirectory: ActivityAreaResponse[];
	responsiblesDirectory: EmployeeSimpleResponse[];
	ownershipTypesDirectory: OwnershipTypeResponse[];
}

const initialState: DirectoriesState = {
	organizationsDirectory: [],
	processClassesDirectory: [],
	objectsTypesDirectory: [],
	activityAreasDirectory: [],
	responsiblesDirectory: [],
	ownershipTypesDirectory: [],
};

const directoriesSlice = createSlice({
	name: "directoriesSlice",
	initialState,
	reducers: {
		increaseBpCount(state, action: PayloadAction<number>) {
			const classIndex: number = state.processClassesDirectory.findIndex((item) => item.id === action.payload);
			state.processClassesDirectory[classIndex].bpCount++;
		},
		decreaseBpCount(state, action: PayloadAction<number>) {
			const classIndex: number = state.processClassesDirectory.findIndex((item) => item.id === action.payload);
			state.processClassesDirectory[classIndex].bpCount--;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(getOrganizationsDirectory.fulfilled, (state, action) => {
			state.organizationsDirectory = action.payload;
		});
		builder.addCase(getProcessClassesDirectory.fulfilled, (state, action) => {
			state.processClassesDirectory = action.payload;
		});
		builder.addCase(getObjectsTypesDirectory.fulfilled, (state, action) => {
			state.objectsTypesDirectory = action.payload;
		});
		builder.addCase(getActivityAreasDirectory.fulfilled, (state, action) => {
			state.activityAreasDirectory = action.payload;
		});
		builder.addCase(getResponsiblesDirectory.fulfilled, (state, action) => {
			state.responsiblesDirectory = action.payload;
		});
		builder.addCase(getOwnershipTypesDirectory.fulfilled, (state, action) => {
			state.ownershipTypesDirectory = action.payload;
		});
	},
});

export const { increaseBpCount, decreaseBpCount } = directoriesSlice.actions;
export default directoriesSlice.reducer;
